import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { BookOpen, FileSpreadsheet, Award, Palette, FileText, ChevronRight, Trophy } from 'lucide-react';

export const SertifikalarHubContent = ({ setActiveSection }) => {
  const sections = [
    { id: 'education-programs', title: 'Eğitim Programları', description: 'Eğitim adı ve saatlerini yönet', icon: <BookOpen className="w-6 h-6" />, stats: 'Programlar', color: 'blue' },
    { id: 'bulk-certificates', title: 'Toplu Sertifika Basımı', description: 'Excel ile toplu sertifika oluştur', icon: <FileSpreadsheet className="w-6 h-6" />, stats: 'Toplu Basım', color: 'green' },
    { id: 'certificates', title: 'Sertifika Yönetimi', description: 'Öğrenci sertifikalarını görüntüle ve yönet', icon: <Award className="w-6 h-6" />, stats: 'Sertifikalar', color: 'amber' },
    { id: 'certificate-design', title: 'Sertifika Tasarımı', description: 'Sertifika şablonu tasarla ve düzenle', icon: <Palette className="w-6 h-6" />, stats: 'Tasarım', color: 'purple' },
    { id: 'agreements', title: 'Sözleşme Yönetimi', description: 'Öğrenci sözleşmeleri ve onayları', icon: <FileText className="w-6 h-6" />, stats: 'Sözleşmeler', color: 'indigo' }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    amber: 'bg-amber-100 text-amber-600',
    purple: 'bg-purple-100 text-purple-600',
    indigo: 'bg-indigo-100 text-indigo-600'
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-5 pb-3 border-b border-gray-200">
        <div className="p-2 bg-amber-600 rounded-lg text-white">
          <Trophy className="w-5 h-5" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800">Sertifikalar</h2>
          <p className="text-sm text-gray-500">Sertifika ve sözleşme yönetimi</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sections.map(section => (
          <Card 
            key={section.id}
            className="border border-gray-200 hover:border-amber-300 hover:shadow-md transition-all cursor-pointer group bg-white"
            onClick={() => setActiveSection(section.id)}
          >
            <CardContent className="p-5">
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-lg ${colorClasses[section.color]}`}>
                  {section.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-800 group-hover:text-amber-600 transition-colors">{section.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{section.description}</p>
                  <span className="inline-block mt-2 text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">{section.stats}</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-amber-500 group-hover:translate-x-1 transition-all flex-shrink-0" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SertifikalarHubContent;
